import(/* webpackMode: "eager" */ "/vercel/path0/nextjs/src/app/global-error.tsx");
